/** StudioOS Core 3.0.0 */
(() => {
  const root = document.documentElement;
  const body = document.body;
  if (!body) return;
  const config = {
    version: body.dataset.studioosVersion || '3.0.0',
    brand: body.dataset.studioosBrand || 'custom',
    channel: body.dataset.studioosChannel || 'Stable',
    safeMode: root.classList.contains('studioos-safe-mode')
  };
  window.StudioOS = Object.freeze({ ...(window.StudioOS || {}), config });
  document.dispatchEvent(new CustomEvent('studioos:ready', { detail: config }));
})();
